const getUserPreferences = ({ userPreferencesRepository }) => async () =>
  userPreferencesRepository.getUserPreferences();

export default getUserPreferences;
